import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
// attach customer auth token when present (backend treats it as optional auth)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("taven_user_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const money = (amount, currency = "USD") => {
  if (amount == null) return "";
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(amount);
  } catch {
    return `$${Number(amount).toFixed(2)}`;
  }
};

export const getCollection = async (handle, first = 12) => {
  const { data } = await api.get(`/shop/collection/${handle}`, { params: { first } });
  return data;
};

export const getProducts = async (params = {}) => {
  const { data } = await api.get(`/shop/products`, { params });
  return data.products || [];
};

export const getProduct = async (handle) => {
  const { data } = await api.get(`/shop/product/${handle}`);
  return data.product;
};

export const getCollections = async () => {
  const { data } = await api.get(`/shop/collections`, { params: { first: 60 } });
  return data.collections || [];
};

export const getMenu = async () => {
  const { data } = await api.get(`/shop/menu`);
  return data.items || [];
};

export const getShopPages = async () => {
  const { data } = await api.get(`/shop/pages`);
  return data.pages || [];
};

export const getShopPage = async (handle) => {
  const { data } = await api.get(`/shop/page/${handle}`);
  return data.page;
};
